import { faDigits } from '../../../lib/faDigits.js';

/** Token count with Persian digits and `٬` grouping. */
export function formatTokens(value: number): string {
  return Math.abs(Math.trunc(value)).toLocaleString('fa-IR');
}

/** Signed token delta («+۱۰۰٬۰۰۰» / «−۱٬۰۸۰»); a zero delta renders as «—». */
export function formatTokenDelta(value: number): string {
  if (value === 0) return '—';
  return `${value > 0 ? '+' : '−'}${formatTokens(value)}`;
}

/** Day-of-month axis label (1 … 30) in Persian digits. */
export function dayLabel(day: number): string {
  return faDigits(day);
}
